<p-dataView
  [emptyMessage]="'Empty' | translate"
  #dv
  [value]="thumbList"
  [paginator]="true"
  [rows]="100"
  paginatorPosition="bottom"
  layout="grid"
  >
  <ng-template pTemplate="header">
    <p-checkbox name="group2" binary="true" (onChange)="onSelectAll($event)" inputId="group2"></p-checkbox>
    <label for="group2" class="ml-2">{{'Sel_All' | translate}}</label>
  </ng-template>
  <ng-template pTemplate="grid" let-thumbList>
    <div class="grid pad-p">
      @for (thumb of thumbList; track thumb; let i = $index) {
        <div class="min-max-n border-st m-1">
          <div class="text-size head border-st border-lr">
            <div class="checkbox-background pad-p">
              <p-checkbox
                name=""
                [(ngModel)]="selectedList[i].selected"
                binary="true"
                (onChange)="onSelectThumb($event, selectedList[i])"
              ></p-checkbox>
            </div>
            @if (hasLock === true && thumb.doc_checkoutuser !== '') {
              <div class="lock pad-p">
                @if (thumb.doc_checkoutuser !== currentUser) {
                  <i
                    class="lock-icon-red"
                    data-icons8="&#xf12e;"
                  ></i>
                }@else {
                  <i
                    class="lock-icon-green"
                    data-icons8="&#xf12e;"
                  ></i>
                }
              </div>
            }
            <div class="pad-6">{{ thumb.doc_name }}</div>
          </div>
          <div class="align">
            @if (thumbSize === 160) {
              <img
                class="cursorPointer"
                [ngSrc]="thumb.url"
                width="160" height="240"
                priority="high"
                (click)="onClickImg(thumb)"
                />
            }
            @if (thumbSize === 320) {
              <img
                class="cursorPointer"
                [ngSrc]="thumb.url320"
                width="240" height="320"
                priority="high"
                (click)="onClickImg(thumb)"
                />
            }
          </div>
          <div class="foot border-st border-lr">
            @for (info of thumb.info; track info) {
              <div class="text-size">{{ info.name }} : {{ info.value }}</div>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
</p-dataView>
